import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
// import Observer from '@researchgate/react-intersection-observer';
import IntersectionObserver from 'intersection-observer-polyfill';
let isFirstExposure = false;

const Review = ({ content, setNavIndex, guestData = [] }) => {
    const guestDataNum = guestData.length || 0;
    // const getPrintableThreshold = (ratio, range) => range.reduce((prev, curr) => (Math.abs(curr - ratio) < Math.abs(prev - ratio) ? curr : prev));
    // const handleChange = ({ isIntersecting, intersectionRatio }) => {
    //     if (getPrintableThreshold(intersectionRatio.toFixed(2), [1]) === 1 && isFirstExposure) {
    //         setNavIndex(guestDataNum);
    //     }
    // };

    useEffect(() => {
        setTimeout(() => {
            isFirstExposure = true;
        }, 1000);

        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.intersectionRatio === 1 && isFirstExposure) {
                        const activeIndex = parseInt(entry.target.getAttribute('index'));

                        setNavIndex(activeIndex);
                    }
                    // console.log(entry.intersectionRatio === 1, entry.target.getAttribute('index'), '2222222');
                });
            },
            {
                threshold: [1],
            }
        );

        observer.observe(document.querySelector(`#guestBox_${guestDataNum}`));
    }, []);

    return content?.length > 0 ? (
        // <Observer onChange={handleChange} threshold={[1]}>
        <div className={styles.review} id={`guestBox_${guestDataNum}`} index={guestDataNum}>
            <div className={styles.reviewBox}>
                {content.map((item, index) => {
                    return (
                        <a href={item.url} key={index} rel="noreferrer" target="_blank" className={styles.reviewItem}>
                            <div className={styles.reviewItemTitle}>{item.title}</div>
                            <div className={styles.reviewItemPlayIcon} />
                            <div className={styles.reviewItemButton}>点击观看</div>
                        </a>
                    );
                })}
            </div>
        </div>
    ) : // </Observer>
    null;
};

Review.propTypes = {
    content: PropTypes.array,
    guestData: PropTypes.array,
    setNavIndex: PropTypes.func,
};

export default errorBoundary(Review);
